import { FETCH_STARTED, SAVED_SEARCH_FETCH_FAILED, SAVED_SEARCH_FETCH_DONE, SAVED_SEARCH_SUBMIT_DONE, SAVED_SEARCH_SUBMIT_FAILED } from '../actions/actionTypes'

const initialState = {
  savedSearches: [],
  fetching: false,
  error: ''
}

export const userSearches = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_STARTED: {
      return {
        ...state,
        error: '',
        fetching: true
      }
    }
    case SAVED_SEARCH_FETCH_DONE: {
      return {
        ...state,
        savedSearches: action.payload.data.savedSearches,
        error: '',
        fetching: false
      }
    }
    case SAVED_SEARCH_FETCH_FAILED: {
      return {
        ...state,
        error: action.payload.error,
        fetching: false
      }
    }
    case SAVED_SEARCH_SUBMIT_DONE: {
      return {
        ...state,        
        error: '',
        fetching: false
      }
    }
    case SAVED_SEARCH_SUBMIT_FAILED: {
      return {
        ...state,
        error: action.payload.error,
        fetching: false
      }
    }
    default:
      return state
  }
}
